module.exports = __webpack_public_path__ + "static/media/bike.b1814098.png";